import { render, staticRenderFns } from "./TopicView.vue?vue&type=template&id=f3277fc8&scoped=true&"
import script from "./TopicView.vue?vue&type=script&lang=js&"
export * from "./TopicView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3277fc8",
  null
  
)

export default component.exports